import { VStack } from '@direct-frontend/components';
import { DrawerBottomFixed, DrawerButton, DrawerHeader } from '@/shared/components/Drawer';
import styles from './OrderVariantsEditModal.module.css';

export const OrderVariantsEditModalEmpty = ({ onClose }: { onClose?: VoidFunction }) => (
    <VStack className={styles.empty} justifyContent="space-between">
        <VStack className={styles.scroll}>
            <DrawerHeader className={styles.header} title="Вариантов для выбора не найдено" />
        </VStack>

        <VStack className={styles.button}>
            <DrawerBottomFixed isSticky>
                <DrawerButton onClick={onClose}>Закрыть</DrawerButton>
            </DrawerBottomFixed>
        </VStack>
    </VStack>
);
